import React from 'react';

import { MatchHistoryMatchComponent } from 'react/match/MatchHistoryMatchComponent.jsx';
import { Match } from '../../models/Match';
import InfiniteScroll from 'react-infinite-scroller';
import LoaderFullPage from "../elements/LoaderFullPage";

class MatchHistoryTableComponent extends React.Component {
	static defaultProps = {
		hasMore: false,
		loadMore: null,
		perspectivePlayer: null,
		showMatchStatusAlways: false,
		currentPage: 1,
	};

	constructor(props) {
		super(props);
		const { loadMore } = this.props;
		this.state = {
			matches: null,
		};
		this.infiniteScrollerToUse = loadMore ? InfiniteScroll : React.Fragment;
	}

	componentDidMount() {
		this.updateMatchList();
	}

	componentDidUpdate(prevProps) {
		if(prevProps.matches !== this.props.matches) {
			this.updateMatchList();
		}
	}

	updateMatchList() {
		const { matches } = this.props;
		if(!matches) {
			return null;
		}
		let matchList = null;
		if(matches instanceof Match) {
			matchList = [matches];
		}
		else if(Array.isArray(matches)) {
			matchList = [...matches];
		}
		else if(matches instanceof Map) {
			matchList = Array.from(matches).map(([_, match]) => {
				return match;
			});
		}
		else {
			console.error(matches);
			throw new Error('Got an invalid match input?');
		}
		this.setState({
			matches: matchList
		});
	}


	render() {
		const { onMatchClick, children, loading, hasMore, loadMore, perspectivePlayer, showMatchStatusAlways, getScrollParent, currentPage } = this.props;
		const { matches } = this.state;
		if(!matches && !children) {
			return null;
		}

		const InfiniteScrollerToUse = this.infiniteScrollerToUse;
		const infiniteScrollProps = {};
		if(loadMore) {
			infiniteScrollProps.pageStart = currentPage;
			infiniteScrollProps.loadMore = loadMore;
			infiniteScrollProps.hasMore = hasMore;
			infiniteScrollProps.initialLoad = false;
			infiniteScrollProps.getScrollParent = getScrollParent;
			infiniteScrollProps.useWindow = !getScrollParent;
		}

		return (
			<div className='match-history-table match_history_display'>
				{!!children && children}

				<InfiniteScrollerToUse
					{...infiniteScrollProps}
				>
					{!children && matches.map((match) => (
							<MatchHistoryMatchComponent
								onClick={onMatchClick}
								key={match.id}
								players={match.getPlayers()}
								match={match}
								perspectivePlayer={perspectivePlayer}
								showMatchStatusAlways={showMatchStatusAlways}
							/>
						)
					)}
				</InfiniteScrollerToUse>
				{loading &&
				<LoaderFullPage />
				}
				<div className='loading_more_shower'>
					<div className='loading_display circle-loader-holder'>
						<svg className='circle-loader' width='40' height='40' version='1.1'
						     xmlns='http://www.w3.org/2000/svg'>
							<circle cx='20' cy='20' r='15' />
						</svg>
					</div>
				</div>
			</div>
		);
	}

}

export { MatchHistoryTableComponent };